export default __webpack_public_path__ + "static/media/usdt.0bf38263.svg";